@let i18nPrefixValue = i18nPrefix();
@let i18nValidatorPrefix = `${i18nPrefixValue}.VALIDATORS`;
@let controls = parentForm().controls;
@let publishedToCompareValidatorError = `${i18nValidatorPrefix}.PUBLISHED_TO.compareValidatorError`;
@let form = parentForm();

<mat-card
  *transloco="let t; prefix: i18nPrefixValue"
  class="overflow-hidden relative h-full"
  [formGroup]="form"
>
  <mat-card-content>
    <div class="flex w-full gap-8">
      <mat-slide-toggle
        formControlName="isPublishNotificationEnabled"
        name="is-publish-notification-enabled"
        >{{ t('IS_PUBLISH_NOTIFICATION_ENABLED') }}</mat-slide-toggle
      ></div
    >
    <mat-divider class="!my-4" style="margin-left: -1rem; margin-right: -1rem" />
    <div class="flex flex-col w-full gap-3">
      <mat-form-field class="w-full">
        <mat-label>{{ `${i18nPrefixValue}.PUBLISHED_FROM` | transloco }}</mat-label>
        <input
          cappusPreventKeyDown
          formControlName="publishedFrom"
          matInput
          name="published-from"
          [ngxMatDatetimePicker]="publishedFromPicker"
          (click)="publishedFromPicker.open()"
        />
        <ngx-mat-datepicker-toggle matSuffix [for]="publishedFromPicker" />
        <ngx-mat-datetime-picker #publishedFromPicker />
        <button
          cappusPreventClick
          mat-icon-button
          matSuffix
          type="button"
          [disabled]="controls.publishedFrom.value === null || controls.publishedFrom.disabled"
          (click)="controls.publishedFrom.setValue(null)"
        >
          <mat-icon customMatSvgIcon="pct-mdi-close-circle" />
        </button>
        <mat-error [control]="controls.publishedFrom" />
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-label>{{ `${i18nPrefixValue}.PUBLISHED_TO` | transloco }}</mat-label>
        <input
          cappusPreventKeyDown
          formControlName="publishedTo"
          matInput
          name="published-to"
          [ngxMatDatetimePicker]="publishedToPicker"
          (click)="publishedToPicker.open()"
        />
        <ngx-mat-datepicker-toggle matSuffix [for]="publishedToPicker" />
        <ngx-mat-datetime-picker #publishedToPicker />
        <button
          cappusPreventClick
          mat-icon-button
          matSuffix
          type="button"
          [disabled]="controls.publishedTo.value === null || controls.publishedTo.disabled"
          (click)="controls.publishedTo.setValue(null)"
        >
          <mat-icon customMatSvgIcon="pct-mdi-close-circle" />
        </button>
        <mat-error
          [control]="controls.publishedTo"
          [overrideErrors]="{
            compareValidatorError: publishedToCompareValidatorError,
          }"
        />
      </mat-form-field>
    </div>
  </mat-card-content>
  @if (loading()) {
    <pct-common-progress-bar />
  }
</mat-card>
